import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router";
import { connect } from "react-redux";

const UserRoute = ({ iAuthentificated, layout:Layout,isConfirmed , component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      iAuthentificated && isConfirmed ? 
      <Layout>
        <Component {...props} />
      </Layout>
      : 
      !isConfirmed ?  <Redirect to="/confirmaccount" /> :
      <Redirect to="/" />
    }
  />
);
UserRoute.propTypes = {
  component: PropTypes.any.isRequired,
  iAuthentificated: PropTypes.bool.isRequired
};
function mapStateToProps(state) {
  return {
    iAuthentificated: state.login.isAuthenticated,
    isConfirmed: state.login.isConfirmed
  };
}

export default connect(mapStateToProps)(UserRoute);
